import { render } from "./SAPorders.vue?vue&type=template&id=232597ce&scoped=true"
import script from "./SAPorders.vue?vue&type=script&lang=js"
export * from "./SAPorders.vue?vue&type=script&lang=js"

import "./SAPorders.vue?vue&type=style&index=0&id=232597ce&scoped=true&lang=css"

import exportComponent from "/private/var/www/html/digicheck-laravel-vue-app/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232597ce"]])

export default __exports__